import * as s from "../../styles";

type MissionTextProps = {
    children: React.ReactNode;
};

export const MissionText = ({ children }: MissionTextProps) => {
    return <s.Text>{children}</s.Text>;
};
